exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".workplace{color:#fff!important}.logo{width:123px;height:44px}.nav-title{position:relative;float:left;margin:8px 100px 0 10px;outline:none}.el-menu-item{font-size:16px;height:60px!important;line-height:60px!important;color:#fff!important}.el-menu-item.is-active,.el-menu-item:hover{background-color:#363c48!important;border-bottom:3px solid #579add!important;border-bottom-color:#579add!important}.el-submenu__title{color:#fff!important}.name{color:#fff}.separator{color:#fff}.logout,.separator{margin-left:10px}.tip-pane{float:right;height:60px!important;line-height:60px!important;outline:none}", ""]);

// exports
